import useSessionStore from "@features/session/hooks/useSessionStore";
import { useAppTheme } from "@hooks/useAppTheme";
import { ScrollView } from "react-native";
import { Dialog, IconButton, Portal } from "react-native-paper";
import { ProethicaPrinciplesExplorer } from "./ProethicaPrinciplesExplorer";
import { useProethicaPrinciples } from "./data";

type Props = {
	visible: boolean;
	handleClose: () => void;
};

export const ProethicaPrinciplesDialog = ({ visible, handleClose }: Props) => {
	const theme = useAppTheme();
	const principles = useProethicaPrinciples();
	const reviewedTitles = useSessionStore(
		(state) => state.reviewedPrincipleKeys,
	);
	const markPrincipleReviewed = useSessionStore(
		(state) => state.markPrincipleReviewed,
	);

	return (
		<Portal>
			<Dialog
				visible={visible}
				onDismiss={handleClose}
				style={{
					alignSelf: "center",
					width: "92%",
					maxWidth: 600,
					maxHeight: "85%",
					backgroundColor: theme.colors.surface,
					overflow: "hidden",
				}}
			>
				<Dialog.ScrollArea
					style={{ paddingHorizontal: 0, borderColor: "transparent" }}
				>
					<ScrollView showsVerticalScrollIndicator={false}>
						<ProethicaPrinciplesExplorer
							principles={principles}
							reviewedTitles={reviewedTitles}
							onReviewTitle={markPrincipleReviewed}
							headerAction={
								<IconButton
									icon="close"
									size={20}
									style={{ margin: 0 }}
									onPress={handleClose}
									accessibilityLabel="Close"
								/>
							}
						/>
					</ScrollView>
				</Dialog.ScrollArea>
			</Dialog>
		</Portal>
	);
};
